'use client'

import { useState, useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/auth-context'
import { LoginModal } from '@/components/auth/login-modal'
import { UserAvatarMenu } from '@/components/auth/user-avatar-menu'
import { useLanguage } from '@/contexts/language-context'

interface AuthButtonProps {
  variant?: 'default' | 'outline' | 'secondary' | 'ghost'
  size?: 'default' | 'sm' | 'lg' | 'icon'
  className?: string
}

export function AuthButton({ variant = 'default', size = 'default', className = '' }: AuthButtonProps) {
  const { user, isLoading } = useAuth()
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  const [isSigningIn, setIsSigningIn] = useState(false)
  const { t } = useLanguage()

  useEffect(() => {
    if (isLoading && !user) {
      setIsSigningIn(true)
    } else {
      setIsSigningIn(false)
    }
  }, [isLoading, user])

  if (isSigningIn) {
    return (
      <Button
        variant={variant}
        size={size}
        className={`${className} opacity-50`}
        disabled
      >
        {t("button.loading") || "Loading..."}
      </Button>
    )
  }

  if (user) {
    return <UserAvatarMenu />
  }

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => setIsLoginModalOpen(true)}
      >
        {t("button.getStarted") || "Get Started"}
      </Button>
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </>
  )
} 